import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import './TOOLTIP.css';

class TOOLTIP extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { active: false, x: 0, y: 0 };
    }

    componentWillMount() {
        this.globalDismissHandler = window.WINAPI.SetWinEventHook('dismiss', () => {
            if (this.state.active == true) {
                this.setState({ active: false });
            }
        });
    }

    componentWillUnmount() {
        window.WINAPI.UnhookWinEvent('dismiss', this.globalDismissHandler);
    }

    calculateTooltipPosition(mousePos, parent) {
        var selfRect = this.tooltip.getBoundingClientRect();
        var parentRect = parent.getBoundingClientRect();

        var x = mousePos[0];
        var y = parentRect.top - selfRect.height - 2;

        if (x + selfRect.width > window.innerWidth) {
            x = window.innerWidth - selfRect.width;
        }
        if (y < 0) {
            y = 0;
        }

        // TODO do not be clipped by edges of screen
        return [x, y];
    }

    registerEvents = (rootElem) => {
        if (rootElem == null) {
            this.parent.removeEventListener("mouseenter", this.mouseenter);
            this.parent.removeEventListener("mouseleave", this.mouseleave);
            this.mouseenter = undefined;
            this.mouseleave = undefined;
            clearTimeout(this.timeout);
            return;
        }
        if (this.mouseenter !== undefined) {
            // already bound
            return;
        };

        this.mouseenter = (e) => {
            this.timeout = setTimeout(() => {
                var mousePosition = window.WINAPI.GetCursorPos();
                var tooltipPos = this.calculateTooltipPosition(mousePosition, rootElem.parentElement);
                this.setState({ active: true, x: tooltipPos[0], y: tooltipPos[1] });
            }, 700);
        };
        this.mouseleave = (e) => {
            this.setState({ active: false });
            clearTimeout(this.timeout);
        };

        this.parent = rootElem.parentElement;
        this.parent.addEventListener("mouseenter", this.mouseenter);
        this.parent.addEventListener("mouseleave", this.mouseleave);
    }

    render() {
        var className = "tooltip";
        var content = null;
        if (this.state.active) {
            className += " tooltip-active";
        }
        var style = { left: this.state.x, top: this.state.y };
        return <div className="tooltip-dummy" ref={this.registerEvents}>
            {ReactDOM.createPortal(
            <div className={className} style={style} ref={(tooltip) => { this.tooltip = tooltip; }}>
                {this.props.text}
            </div>,
            window.WINAPI.GetDesktopWindow())}
        </div>;
    }
}

export default TOOLTIP;



// WEBPACK FOOTER //
// ./src/walleris/TOOLTIP.js